<template>
                    <button v-if="biz.name" class="btn btn-sm" :id="'btn' + this.TbtnId" @click="showModal()">{{ biz.name }}</button>



        <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  role="dialog"
          aria-labelledby="myLargeModalLabel" aria-hidden="true" v-if="active && Tbiz.type !== 'ROOT' && !this.$parent.loadMore">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="this.$root.guiPerm == 'ROOT'">관리자 수정</h5>
                <h5 class="modal-title" id="exampleModalLongTitle" v-if="this.$root.guiPerm == 'ENTERPRISE'">클래스 수정</h5>

              </div>
              <div class="modal-body">
                <table class="table table-hover">
                  <tbody>
                    <tr>
                      <td class="th_bg">관리자코드</td>
                      <td>자동생성</td>
                      <td class="th_bg">사용여부</td>
                      <td>
                        <div class="input-group mb-12">
                          <div class="input-group-prepend">
                            <select class="custom-select flex_center" id="inputGroupSelect01" :value="nvl(changedData.suspended, Tbiz.suspended)"
                          :class="{'hidtype-changed': changedData.suspended}"
                          @input="doChange('suspended', $event.target.value)">
                              <option selected>선택</option>
                              <option value="">사용</option>
                              <option value="계약취소">미사용(계약취소)</option>
                              <option value="해지">미사용(해지)</option>
                              <option value="기타사유">미사용(기타)</option>
                            </select>                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.suspended"
                          @click="delete changedData.bankCode"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">생성</td>
                      <td>

                        <tree-btn :tree="this.$refs.bizTree" />
                      </td>
                      <td class="th_bg">생성위치</td>
                      <td>
                        <Business v-for="history in selHistory" :key="history.id" :biz="history" />
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">소속구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'"><button
                            class="btn btn-primary btn-sm">본사</button></template>
                        <template v-if="selBiz.type == 'LOCAL'"><button
                            class="btn btn-info btn-sm">지사</button></template>
                        <template v-if="selBiz.type == 'ENTERPRISE'"><button
                            class="btn btn-success btn-sm">학원</button></template>
                        <template v-if="selBiz.type == 'CLASS'"><button
                            class="btn btn-warning btn-sm">클래스명</button></template>
                      </td>
                      <td class="th_bg">관리구분</td>
                      <td>
                        <template v-if="selBiz.type == 'ROOT'">지사</template>
                        <template v-if="selBiz.type == 'LOCAL'">학원</template>
                        <template v-if="selBiz.type == 'ENTERPRISE'">클래스</template>
                      </td>
                    </tr>

                    <tr v-if="selBiz.type != 'ENTERPRISE'">
                      <td class="th_bg">시작일</td>
                      <td>


                        <input type="date" class="hidtype" :value="nvl(changedData.startDate, Tbiz.startDate.substr(0, 10))"
                          :class="{'hidtype-changed': changedData.startDate}"
                          @input="doChange('startDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.startDate"
                          @click="delete changedData.startDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                      <td class="th_bg">종료일</td>
                      <td>
                        <input type="date" class="hidtype" :value="nvl(changedData.endDate, Tbiz.endDate.substr(0, 10))"
                          :class="{'hidtype-changed': changedData.endDate}"
                          @input="doChange('endDate', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.endDate"
                          @click="delete changedData.endDate"><i class="bi bi-arrow-counterclockwise"></i></button>


                      </td>
                    </tr>


                  </tbody>
                </table>


                <table class="table" v-if="selBiz.type == 'ROOT' || selBiz.type == 'LOCAL'">
                  <tbody>
                    <tr>
                      <td class="th_bg">사업자등록번호</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.bizNo, Tbiz.bizNo)"
                          :class="{'hidtype-changed': changedData.bizNo}"
                          @input="doChange('bizNo', $event.target.value)" placeholder="000-00-00000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bizNo"
                          @click="delete changedData.bizNo"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg" v-if="this.$root.guiPerm == 'ROOT'">학원명</td>
                      <td class="th_bg" v-if="this.$root.guiPerm == 'ENTERPRISE'">클래스명</td>

                      <td>
                        <input class="hidtype" :value="nvl(changedData.name, Tbiz.name)"
                          :class="{'hidtype-changed': changedData.name}" @input="doChange('name', $event.target.value)"
                          placeholder="홍길동" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.name"
                          @click="delete changedData.name"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>

                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td><input class="hidtype" :value="nvl(changedData.tel, Tbiz.tel)"
                          :class="{'hidtype-changed': changedData.tel}" @input="doChange('tel', $event.target.value)"
                          placeholder="02-1544-7000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.tel"
                          @click="delete changedData.tel"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">휴대폰</td>
                      <td><input class="hidtype" :value="nvl(changedData.phone, Tbiz.phone)"
                          :class="{'hidtype-changed': changedData.phone}" @input="doChange('phone', $event.target.value)"
                          placeholder="010-1544-7000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.phone"
                          @click="delete changedData.phone"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">대표자명</td>
                      <td><input class="hidtype" :value="nvl(changedData.headName, Tbiz.headName)"
                          :class="{'hidtype-changed': changedData.headName}" @input="doChange('headName', $event.target.value)"
                          placeholder="010-1544-7000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.headName"
                          @click="delete changedData.headName"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>

                      <td class="th_bg">주민번호</td>
                      <td><input class="hidtype" :value="nvl(changedData.ssn, Tbiz.ssn)"
                          :class="{'hidtype-changed': changedData.ssn}" @input="doChange('ssn', $event.target.value)"
                          placeholder="000000-0000000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ssn"
                          @click="delete changedData.ssn"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>

                    <tr>
                      <td class="th_bg">이메일</td>
                      <td >
                        <input class="hidtype"  :value="nvl(changedData.email, Tbiz.email)"
                          :class="{'hidtype-changed': changedData.email}"
                          @input="doChange('email', $event.target.value)" placeholder="support@mypathkr.com" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.email"
                          @click="delete changedData.email"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">학습타입</td>
                    <td>
                      <select class="custom-select flex_center" id="inputGroupSelect02" :value="nvl(changedData.study_type, Tbiz.study_type)"
                          :class="{'hidtype-changed': changedData.study_type}"
                          @input="doChange('study_type', $event.target.value)">
                              <option value="PLS">PLS</option>
                              <!--option value="ALS">ALS</option-->

                      </select>
                    </td>

                    </tr>
                    <tr>
                      <td class="th_bg">주 소</td>
                      <td colspan="3">
                        <input class="hidtype" style="width:80%;  margin:2px;" :value="nvl(changedData.address1, Tbiz.address1)"
                          :class="{'hidtype-changed': changedData.address1}"
                          @input="doChange('address1', $event.target.value)" placeholder="주소(도로명주소까지)" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.address1"
                          @click="delete changedData.address1"><i class="bi bi-arrow-counterclockwise"></i></button>
                        <br>
                        <input class="hidtype" style="width:80%; margin:2px;" :value="nvl(changedData.address2, Tbiz.address2)"
                          :class="{'hidtype-changed': changedData.address2}"
                          @input="doChange('address2', $event.target.value)" placeholder="주소(호수)" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.address2"
                          @click="delete changedData.address2"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    
                    </tr>
                    <tr>
                      <td class="th_bg">학원등록번호</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.cam_number, Tbiz.cam_number)"
                          :class="{'hidtype-changed': changedData.cam_number}" @input="doChange('cam_number', $event.target.value)"
                          placeholder="학원등록번호" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.cam_number"
                          @click="delete changedData.cam_number"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>

                      <td class="th_bg">교습과목</td>
                      <td><input class="hidtype" :value="nvl(changedData.cam_class, Tbiz.cam_class)"
                          :class="{'hidtype-changed': changedData.cam_class}" @input="doChange('cam_class', $event.target.value)"
                          placeholder="교습과목" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.cam_class"
                          @click="delete changedData.cam_class"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">교습시간</td>
                      <td colspan="3">
                        <input class="hidtype" style="width:80%;  margin:2px;" :value="nvl(changedData.cam_time, Tbiz.cam_time)"
                          :class="{'hidtype-changed': changedData.cam_time}" @input="doChange('cam_time', $event.target.value)"
                          placeholder="교습시간" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.cam_time"
                          @click="delete changedData.cam_time"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">교습비용</td>
                      <td colspan="3">
                        <input class="hidtype" style="width:80%;  margin:2px;" :value="nvl(changedData.cam_expense, Tbiz.cam_expense)"
                          :class="{'hidtype-changed': changedData.cam_expense}" @input="doChange('cam_expense', $event.target.value)"
                          placeholder="교습비용" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.cam_expense"
                          @click="delete changedData.cam_expense"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">은행</td>
                      <td><select class="hidtype" :value="nvl(changedData.bankCode, Tbiz.bankCode)"
                          :class="{'hidtype-changed': changedData.bankCode}"
                          @input="doChange('bankCode', $event.target.value)">


                          <option value="001_한국은행">한국은행</option>
                          <option value="002_산업은행">산업은행</option>
                          <option value="003_기업은행">기업은행</option>
                          <option value="004_국민은행">국민은행</option>
                          <option value="007_수협중앙회">수협중앙회</option>
                          <option value="008_수출입은행">수출입은행</option>
                          <option value="011_농협은행">농협은행</option>
                          <option value="012_지역농축협">지역농축협</option>
                          <option value="020_우리은행">우리은행</option>
                          <option value="023_SC은행">SC은행</option>
                          <option value="027_한국씨티은행">한국씨티은행</option>
                          <option value="031_대구은행">대구은행</option>
                          <option value="032_부산은행">부산은행</option>
                          <option value="034_광주은행">광주은행</option>
                          <option value="035_제주은행">제주은행</option>
                          <option value="037_전북은행">전북은행</option>
                          <option value="039_경남은행">경남은행</option>
                          <option value="045_새마을금고중앙회">새마을금고중앙회</option>
                          <option value="048_신협중앙회">신협중앙회</option>
                          <option value="050_상호저축은행">상호저축은행</option>
                          <option value="071_우체국">우체국</option>
                          <option value="081_하나은행">하나은행</option>
                          <option value="080_하나은행 (080)">하나은행 (080)</option>
                          <option value="082_하나은행 (082)">하나은행 (082)</option>
                          <option value="088_신한은행">신한은행</option>
                          <option value="089_K뱅크">K뱅크</option>
                          <option value="090_카카오뱅크">카카오뱅크</option>
                          <option value="209_유안타증권">유안타증권</option>
                          <option value="218_현대증권">현대증권</option>
                          <option value="230_미래에셋증권">미래에셋증권</option>
                          <option value="238_대우증권">대우증권</option>
                          <option value="240_삼성증권">삼성증권</option>
                          <option value="243_한국투자증권">한국투자증권</option>
                          <option value="247_우리투자증권">우리투자증권</option>
                          <option value="261_교보증권">교보증권</option>
                          <option value="262_하이투자증권">하이투자증권</option>
                          <option value="263_HMC투자증권">HMC투자증권</option>
                          <option value="264_키움증권">키움증권</option>
                          <option value="265_이베스트투자증권">이베스트투자증권</option>
                          <option value="266_SK증권">SK증권</option>
                          <option value="267_대신증권">대신증권</option>
                          <option value="268_아이엠투자증권">아이엠투자증권</option>
                          <option value="269_한화투자증권">한화투자증권</option>
                          <option value="270_하나대투자증권">하나대투자증권</option>
                          <option value="278_신한금융투자">신한금융투자</option>
                          <option value="279_동부증권">동부증권</option>
                          <option value="280_유진투자증권">유진투자증권</option>
                          <option value="288_카카오페이증권">카카오페이증권</option>
                          <option value="287_메리츠종합금융증권">메리츠종합금융증권</option>
                          <option value="290_부국증권">부국증권</option>
                          <option value="291_신영증권">신영증권</option>
                          <option value="292_LIG투자증권">LIG투자증권</option>
                          <option value="092_토스뱅크">토스뱅크</option>
                          <option value="271_토스증권">토스증권</option>
                        </select>
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bankCode"
                          @click="delete changedData.bankCode"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">예금주</td>
                      <td><input class="hidtype" :value="nvl(changedData.bankName, Tbiz.bankName)"
                          :class="{'hidtype-changed': changedData.bankName}"
                          @input="doChange('bankName', $event.target.value)" placeholder="홍길동" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bankName"
                          @click="delete changedData.bankName"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">계좌번호</td>
                      <td colspan="3"><input class="hidtype" :value="nvl(changedData.bankNum, Tbiz.bankNum)"
                          :class="{'hidtype-changed': changedData.bankNum}"
                          @input="doChange('bankNum', $event.target.value)" placeholder="270-16-575402" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bankNum"
                          @click="delete changedData.bankNum"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <!--tr>
                      <td class="th_bg">미국ID</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_USID, Tbiz.ag_USID)"
                          :class="{'hidtype-changed': changedData.ag_USID}"
                          @input="doChange('ag_USID', $event.target.value)" placeholder="미국 아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_USID"
                          @click="delete changedData.ag_USID"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">미국PW</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_USPW, Tbiz.ag_USPW)"
                          :class="{'hidtype-changed': changedData.ag_USPW}"
                          @input="doChange('ag_USPW', $event.target.value)" placeholder="미국 비밀번호" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_USPW"
                          @click="delete changedData.ag_USPW"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr-->
                    <tr>
                      <td class="th_bg">학습관ID</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_STID, Tbiz.ag_STID)"
                          :class="{'hidtype-changed': changedData.ag_STID}"
                          @input="doChange('ag_STID', $event.target.value)" placeholder="학습관 아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_STID"
                          @click="delete changedData.ag_STID"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">학습관PW</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_STPW, Tbiz.ag_STPW)"
                          :class="{'hidtype-changed': changedData.ag_STPW}"
                          @input="doChange('ag_STPW', $event.target.value)" placeholder="학습관 비밀번호" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_STPW"
                          @click="delete changedData.ag_STPW"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">쇼핑몰ID</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_SWID, Tbiz.ag_SWID)"
                          :class="{'hidtype-changed': changedData.ag_SWID}"
                          @input="doChange('ag_SWID', $event.target.value)" placeholder="쇼핑몰 아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_SWID"
                          @click="delete changedData.ag_SWID"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">LMS ID</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_LMSID, Tbiz.ag_LMSID)"
                          :class="{'hidtype-changed': changedData.ag_LMSID}"
                          @input="doChange('ag_LMSID', $event.target.value)" placeholder="LMS 아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_LMSID"
                          @click="delete changedData.ag_LMSID"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table" v-if="selBiz.type == 'LOCAL'">
                  <tbody>
                    <tr>
                      <td class="th_bg">표시 상품 Group</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.agreementType, Tbiz.agreementType)"
                          :class="{'hidtype-changed': changedData.agreementType}"
                          @input="doChange('agreementType', $event.target.value)" placeholder="Group 입력" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.agreementType"
                          @click="delete changedData.agreementType"><i
                            class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg" rowspan="1">설정</td>
                      <td>
                      </td>
                    </tr>
                    <!--tr>
                      <td class="th_bg">초도물품</td>
                      <td>
                        <select name="inputGroupSelect" class="" id="inputGroupSelect">
                          <option selected>ALL</option>
                        </select><input type="date" />
                      </td>

                      <td>
                        <label>
                          <input type="radio" name="RadioGroup1" value="보카조아" id="RadioGroup1_1">
                          보카조아[종료:22-01-20]</label></td>
                    </tr>
                    <tr>
                      <td class="th_bg">상품적용<button class="btn btn-danger btn-sm" data-toggle="modal"
                          data-target="#exampleModal">추가</button>

                        <-- Modal
                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
                          aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>

                              </div>
                              <div class="modal-body">
                                <p class="mb-0">Lorem Ipsum has been the industry's standard dummy text ever since the
                                  1500s, when an unknown printer took a galley of type and scrambled.</p>
                              </div>
                              <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button type="button" class="btn btn-primary">Save changes</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td colspan="3"> p123,p124 </td>
                    </tr-->

                  </tbody>
                </table>

                <table class="table" v-if="selBiz.type == 'ENTERPRISE'">
                  <tbody>
                    <tr>
                      <td class="th_bg"><i class="fas fa-check-circle"></i>클래스명</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.name, Tbiz.name)"
                          :class="{'hidtype-changed': changedData.name}" @input="doChange('name', $event.target.value)"
                          placeholder="홍길동" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.name"
                          @click="delete changedData.name"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <!--td class="th_bg"><i class="fas fa-check-circle"></i>클래스명(영문)</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.engName, Tbiz.engName)"
                          :class="{'hidtype-changed': changedData.engName}"
                          @input="doChange('engName', $event.target.value)" placeholder="홍길동" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.engName"
                          @click="delete changedData.engName"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td class="th_bg">연락처</td>
                      <td><input class="hidtype" :value="nvl(changedData.tel, Tbiz.tel)"
                          :class="{'hidtype-changed': changedData.tel}" @input="doChange('tel', $event.target.value)"
                          placeholder="02-1544-7000" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.tel"
                          @click="delete changedData.tel"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td-->
                      <td class="th_bg">대표강사명</td>
                      <td>
                        <input class="hidtype" :value="nvl(changedData.headName, Tbiz.headName)"
                          :class="{'hidtype-changed': changedData.headName}"
                          @input="doChange('headName', $event.target.value)" placeholder="홍길동" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.headName"
                          @click="delete changedData.headName"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr>
                    <!--tr>
                      <td class="th_bg">미국ID</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_USID, Tbiz.ag_USID)"
                          :class="{'hidtype-changed': changedData.ag_USID}"
                          @input="doChange('ag_USID', $event.target.value)" placeholder="미국 아이디" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_USID"
                          @click="delete changedData.ag_USID"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                      <td class="th_bg">미국PW</td>
                      <td><input class="hidtype" :value="nvl(changedData.ag_USPW, Tbiz.ag_USPW)"
                          :class="{'hidtype-changed': changedData.ag_USPW}"
                          @input="doChange('ag_USPW', $event.target.value)" placeholder="미국 비밀번호" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.ag_USPW"
                          @click="delete changedData.ag_USPW"><i class="bi bi-arrow-counterclockwise"></i></button>
                      </td>
                    </tr-->


                                        <tr>
                      <td class="th_bg">요일</td>
                      <td>
                        <table >
                          <colgroup>
<col style="width:33%;" />
<col style="width:33%;" />
<col style="width:33%;" />

                          </colgroup>
                          <tr>
                            <td>
                              <li class="form-check form-switch" style="width:80px;">
        <input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_0" @change="changedData.class_day_0 = !(changedData.class_day_0 || Tbiz.class_day_0)">
        <label class="form-check-label">일</label>
    </li>
                            </td>
                            <td>
                              <li class="form-check form-switch" style="width:80px;">
  <input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_1"  @change="changedData.class_day_1 = !(changedData.class_day_1 || Tbiz.class_day_1)">
  <label class="form-check-label">월</label>
</li>
                            </td>
                            <td>
                              <div class="form-check form-switch">
<input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_2"  @change="changedData.class_day_2 = !(changedData.class_day_2 || Tbiz.class_day_2)">
<label class="form-check-label">화</label>
</div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <li class="form-check form-switch" style="width:80px;">
        <input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_3"  @change="changedData.class_day_3 = !(changedData.class_day_3 || Tbiz.class_day_3)">
        <label class="form-check-label">수</label>
    </li>
                            </td>
                            <td>
                              <li class="form-check form-switch" style="width:80px;">
  <input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_4"  @change="changedData.class_day_4 = !(changedData.class_day_4 || Tbiz.class_day_4)">
  <label class="form-check-label">목</label>
</li>
                            </td>
                            <td>
                              <div class="form-check form-switch">
<input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_5"  @change="changedData.class_day_5 = !(changedData.class_day_5 || Tbiz.class_day_5)">
<label class="form-check-label">금</label>
</div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <li class="form-check form-switch" style="width:80px;">
        <input class="form-check-input" type="checkbox" :checked="Tbiz.class_day_6"  @change="changedData.class_day_6 = !(changedData.class_day_6 || Tbiz.class_day_6)">
        <label class="form-check-label">토</label>
    </li>
                            </td>
                            <td>

                            </td>
                            <td>

                            </td>
                          </tr>
                        </table>





                      </td>
                      <td class="th_bg">시간</td>
                      <td>
                        <input class="hidtype" type="time" :value="nvl(changedData.class_time, Tbiz.class_time)"
                          :class="{'hidtype-changed': changedData.class_time}"
                          @input="doChange('class_time', $event.target.value)" step="600"  />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.class_time"
                          @click="delete changedData.class_time"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                    </tr>
                                        <tr>
                      <td class="th_bg">학년</td>
                      <td>
                                                <input class="hidtype" :value="nvl(changedData.class_grade, Tbiz.class_grade)"
                          :class="{'hidtype-changed': changedData.class_grade}"
                          @input="doChange('class_grade', $event.target.value)" placeholder="학년"  />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.class_grade"
                          @click="delete changedData.class_grade"><i class="bi bi-arrow-counterclockwise"></i></button>
                    </td>
                      <td class="th_bg">유형</td>
                      <td>

                            <select class="hidtype" :value="nvl(changedData.class_type, Tbiz.class_type)"
                              :class="{'hidtype-changed': changedData.class_type}"
                              @input="doChange('class_type', $event.target.value)">
                            <option value="">지정 없음</option>
                            <option value="ChildU">ChildU</option>
                            <option value="MyPath">MyPath</option>
                            <option value="기타">기타</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.class_type" @click="delete changedData.class_type"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                    </tr>
                                                            <tr>
                      <td class="th_bg">레벨</td>
                      <td>

                            <select class="hidtype" :value="nvl(changedData.class_level, Tbiz.class_level)"
                              :class="{'hidtype-changed': changedData.class_level}"
                              @input="doChange('class_level', $event.target.value)">
                            <option value="">지정 없음</option>
                            <option value="혼합">혼합</option>
                            <option value="GK">GK</option>
                            <option value="GK_1" v-if="(changedData.class_type || Tbiz.class_type) != 'MyPath'">GK_1</option>
                            <option value="GR1">GR1</option>
                            <option value="GR2">GR2</option>
                            <option value="GR3">GR3</option>
                            <option value="GR4">GR4</option>
                            <option value="GR5">GR5</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR6">GR6</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR7">GR7</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR8">GR8</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR9">GR9</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR10">GR10</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR11">GR11</option>
                            <option v-if="(changedData.class_type || Tbiz.class_type) != 'ChildU'" value="GR12">GR12</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.class_level" @click="delete changedData.class_level"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                                </td>
                      <td class="th_bg"></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <br>
                <table class="table" v-if="selBiz.type == 'LOCAL'">
                  <tr style="height:160px;">
                    <th>
                      인사말
                    </th>
                    <td>
                      <textarea style="height:160px; font-size:13px; padding:10px;" type="text" class="form-control" placeholder="여기에 인사말을 작성 .." v-model="Tbiz.intro"></textarea>
                    </td>
                    <td style="text-align:center;">
                      <button class="btn btn-warning btn-sm" @click="addIntro(biz)">작성</button>
                    </td>
                  </tr>

                </table>
                <table class="table" v-if="selBiz.type == 'LOCAL'">
                  <tr>
                    <th colspan="4" style="height:50px;">
                      학원규정
                    </th>

                  </tr>
                </table>
                <table class="table" v-if="selBiz.type == 'LOCAL'">
                  <tr>
                    <th>
                      학원규정 <br>작성
                    </th>
                    <td colspan="4" style="text-align: left; padding: 20px">
                      <SummernoteEditor
                        v-model="Tbiz.cam_content"
                        @summernoteImageLinkInsert="summernoteImageLinkInsert"
                        :config="summernoteConfig"
                        v-if="summernoteReady"
                        ref="summernote"
                      />
                    </td>
                    
                  </tr>
                  <tr >
                    <td colspan="4" style="text-align: center;">
                      <button
                        class="btn btn-warning btn-sm"
                        @click="addCamContent(biz)"
                      >
                        작성
                      </button>
                    </td>
                  </tr>
                </table>
                <br>
                <table class="table" v-if="Tbiz.memos">
                  <tr>
                    <th colspan="4" style="height:50px;">
                      관리메모
                    </th>

                  </tr>
                  <tr v-for="memo in Tbiz.memos" :key="memo.id">

                    <td style="width:50%; text-align:left;">
                      {{ memo.text }}
                    </td>
                    <td>
                      {{ memo.admin_name }}
                    </td>
                    <td>
                      {{ memo.created_at }}
                    </td>
                    <td>
                      <a @click="delMemo(memo)"><button class="btn btn-danger btn-sm">삭제</button></a>
                    </td>

                  </tr>
                </table>
                <table class="table" v-if="Tbiz.memos">
                  <tr>
                    <th>
                      메모작성
                    </th>
                    <td style="height:60px;">
                      <input type="text" class="form-control" style="padding:10px; font-size:13px;" placeholder="여기에 메모를 작성 .." v-model="this.Tbiz.memo" />
                    </td>
                    <td style="text-align:right;">
                      <button class="btn btn-warning btn-sm" @click="addMemo(biz)">작성</button>
                    </td>
                  </tr>

                </table>
                <br>

                <table class="table" v-if="Tbiz.contracts && Tbiz.type == 'ENTERPRISE'">
                  <tr>
                    <th colspan="9" style="height:50px;">
                      계약내용
                    </th>

                  </tr>
                  <tr>
                    <th>본부</th>
                    <th>타입</th>
                    <th>계약금</th>
                    <th>입금일</th>
                    <th>시작</th>
                    <th>종료</th>
                    <th>내용</th>
                    <th>상태</th>
                    <th>액션</th>
                  </tr>
                  <tr v-for="contract in Tbiz.contracts" :key="contract.id">

                    <td>
                      <Business :biz="contract.p_biz" />
                    </td>
                    <td>
                      {{ contract.type }}
                    </td>
                    <td>
                      {{ parseInt(contract.price).toLocaleString() }}
                    </td>
                    <td>
                      {{ contract.deposit_date }}
                    </td>
                    <td>
                      {{ contract.start_date }}
                    </td>
                    <td>
                      {{ contract.end_date }}
                    </td>
                    <td>
                      {{ contract.extras }}
                    </td>
                    <td>
                      <template v-if="contract.status == 'OK'">완료</template>
                      <template v-if="contract.status == 'CANCELLED'">취소</template>
                    </td>
                    <td>
                      <button class="btn btn-danger btn-sm" @click="endContract(contract)" v-if="contract.status == 'OK'">삭제</button>
                    </td>

                  </tr>
                </table>



                <template v-if="Tbiz.domain">설정된 학원홈페이지 도메인은 <a target="_blank"
                    :href="'https://' + Tbiz.domain + '.mypathkr.com/'">{{Tbiz.domain}}.mypathkr.com</a>
                  입니다.</template>
              </div>
              <div class="modal-footer flex_center">
                <button type="button" class="btn btn-danger" data-bs-toggle="modal" :data-bs-target="'#ModalCrt' + TbtnId" v-if="Tbiz.type == 'ENTERPRISE'">계약추가</button>
                <button type="button" class="btn btn-primary" @click="doSend()">수정</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="this.active=false;">닫기</button>

              </div>
            </div>
          </div>
        </div>


 <!-- 계약관리 클릭시 모달 -->
          <div class="modal fade" style="z-index:2147483647;" :id="'ModalCrt' + TbtnId" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">계약관리</h5>
                  <button type="button" class="btn-close" aria-label="Close">

                  </button>
                </div>
                <div class="modal-body">

                  <table class="table">
                    <tbody>
                      <tr>
                        <td class="td_bg">계약타입</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.type" /></td>
                        <td class="td_bg">가맹비</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.price" /></td>
                      </tr>
                      <tr>
                        <td class="td_bg">입금일</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.deposit_date" type="date"/></td>
                        <td class="td_bg">시작일</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.start_date" type="date"/></td>
                      </tr>
                      <tr>
                        <td class="td_bg">종료일</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.end_date" type="date"/></td>
                         <td class="td_bg">계약사항</td>
                        <td class="tdtd"><input class="hidtype" v-model="contract_info.extras"/></td>
                      </tr>
                      <tr>
                        <td class="td_bg">재계약?</td>
                        <td class="tdtd"><input type="checkbox" v-model="contract_info.is_repeat"/></td>
                         <td class="td_bg">/</td>
                        <td class="tdtd">/</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer" style="border-top:0;">
                  <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="addContract()" >등록</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
                </div>
              </div>
            </div>
          </div>






  <Tree :key="$route.path" :tree-data="this.$root.businesses" :selectable="['ROOT','LOCAL','ENTERPRISE']" :callback="selectedBiz"
    ref="bizTree" v-if="active" />
</template>

<script>
  import Tree from "../components/Tree";
  import axios from "axios";
  import treeBtn from "../components/treeBtn";
  import 'summernote/dist/summernote-lite';
  import 'summernote/dist/summernote-lite.css';
  import SummernoteEditor from 'vue3-summernote-editor';
  import 'summernote-file';
  import jq from "jquery";

export default {
    name: "Business",
        components: {
      Tree,
      treeBtn,
      SummernoteEditor
    },
    props: {
        biz: {type: Object, default: {}},
        btnId: String
    },
    watch: {
      biz(){
        this.Tbiz = this.biz;
      }
    },
    methods: {
        loadMore(){
                    axios.get('/businesses/' + this.Tbiz.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.Tbiz = response.data.result;
            this.changedData.type = this.Tbiz.type;
            this.$refs.bizTree.reset(this.Tbiz.parent);
            this.selBiz = this.Tbiz.parent;
            this.selHistory[0] = this.Tbiz.parent;
          }


        })
        },
              selectedBiz(biz, history) {
        this.selBiz = biz;
        this.selHistory = history;
        if (biz.type == 'LOCAL') {
          this.changedData.type = 'ENTERPRISE';
        }
        if (biz.type == 'ENTERPRISE') {
          this.changedData.type = 'CLASS';
        }
        if (biz.type == 'ROOT') {
          this.changedData.type = 'LOCAL';
        }
      },

      delMemo(memo) {
        axios.delete('/businesses/' + this.Tbiz.id + '/memos/' + memo.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '삭제 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '삭제 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.loadMore()

          }


        })
      },
      addIntro(record) {
        axios.post('/businesses/' + this.Tbiz.id + '/intro', {
          "intro": this.Tbiz.intro,
          "expiresAt": 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '작성 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '작성 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }
        })
      },
      addCamContent(record) {
        axios.post('/businesses/' + this.Tbiz.id + '/content', {
          "cam_content": this.Tbiz.cam_content,
          "expiresAt": 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '작성 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '작성 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }
        })
      },
      addMemo(record) {
        axios.post('/businesses/' + this.Tbiz.id + '/memos', {
          "memo": this.Tbiz.memo,
          "expiresAt": 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '작성 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '작성 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.loadMore()

          }


        })
        this.Tbiz.memo = "";
      },
        endContract(contract) {
        axios.patch('/businesses/' + this.Tbiz.id + '/contracts/' + contract.id, {"status": "CANCELLED"}).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '취소 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '취소 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.loadMore()

          }


        })
      },
            nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      addContract(record) {
        axios.post('/businesses/' + this.Tbiz.id + '/contracts', {
          "type": this.contract_info.type,
          "start_date": this.contract_info.start_date,
          "end_date": this.contract_info.end_date,
          "price": this.contract_info.price,
          "deposit_date": this.contract_info.deposit_date,
          "extras": this.contract_info.extras,
          "is_repeat": this.contract_info.is_repeat ? 1 : 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '등록 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '등록 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.loadMore()

          }


        })
        this.contract_info={
              type: "",
              start_date: "",
              end_date: "",
              deposit_date: "",
              price: "",
              extras: "",
              is_repeat: 0
            };
      },
            doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = {...this.changedData, 'parentBusiness': this.selBiz.id};
        var send = axios({
          method: "patch",
          url: '/businesses/' + this.Tbiz.id,
          data: data
        });
        send.then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.$root.getBusinesses();
            (bootstrap.Modal.getInstance(document.getElementById("Modal" + this.TbtnId))).hide();
            $.notify({
              // options
              message: '처리되었습니다'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }


        })


      },
            doChange(name, value) {
        if (this.Tbiz[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      showModal(){


            if(this.Tbiz.type == 'ROOT'){
            $.notify({
              // options
              message: '루트(MyPath 혹은 MyPath TEST)는 상세정보를 열 수 없습니다.'
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
            return;
            }
            if(this.$parent.loadMore){
                            $.notify({
              // options
              message: '학원정보 창 안에서 또 다시 학원정보 창을 열 수는 없습니다.'
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
            return;
            }
            this.active=true;
                    this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs.modal', function (event) {
            this.active = false;
          })
          modal.show();
        });

        this.loadMore()
        (bootstrap.Modal.getInstance(document.getElementById("Modal" + this.TbtnId))).show();

        

      },
      
    },
    mounted(){
        this.Tbiz = this.biz;
        console.log(this.Tbiz)
        this.summernoteConfig.callbacks.onFileUpload = (files) => {
          const uploadFile = files[0];
          const formData = new FormData();
          formData.append("userfile", uploadFile);

          axios({
            method: "post",
            url: "https://s.mypathkr.com/upload",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              jq(this.$refs.summernote.elem).summernote(
                "pasteHTML",
                '<a href="' +
                  response.data.url +
                  '"><i class="bi bi-file-earmark-arrow-down-fill"></i> ' +
                  uploadFile.name +
                  "</a>"
              );

              //this.changedData.image = response.data.url
            }
          });
        };

        this.summernoteConfig.callbacks.onImageUpload = (files) => {
          const uploadFile = files[0];
          const formData = new FormData();
          formData.append("userfile", uploadFile);

          axios({
            method: "post",
            url: "https://s.mypathkr.com/upload",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              jq(this.$refs.summernote.elem).summernote(
                "editor.insertImage",
                response.data.url
              );

              //this.changedData.image = response.data.url
            }
          });
        };

        this.summernoteReady = true;
    },    
    summernoteChange(newValue) {
      console.log("summernoteChange", newValue);
    },
    summernoteImageLinkInsert(...args) {
      console.log("summernoteImageLinkInsert()", args);
    },
    data(){
        return {
            changedData: {},
            TbtnId: this.btnId || Math.random().toString().substr(2,5),
            selBiz: {
                "name": ""
            },
            selHistory: [],
            Tbiz: {},
            active: false,
            summernoteReady: false,
            summernoteConfig: {
              toolbar: [
                ["style", ["style"]],
                ["font", ["bold", "underline", "clear"]],
                ["fontname", ["fontname"]],
                ["color", ["forecolor", "backcolor"]],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video", "file"]],
                ["view", ["codeview"]],
              ],
              callbacks: {
                onFileUpload: function (files) {},
              },
            },
            contract_info: {
              type: "",
              start_date: "",
              end_date: "",
              deposit_date: "",
              price: "",
              extras: "",
              is_repeat: 0
            }
        }
    }
}
</script>
